import { CustomHeader } from 'components/universal/custom-header';
import { useTranslation } from 'react-i18next';
import { ConfirmResetPasswordView } from 'views/confirm-reset-password';

export const ConfirmResetPassword = () => {
    const { t } = useTranslation('', {
        keyPrefix: 'SEO.confirmResetPassword',
    });

    return (
        <div>
            <CustomHeader title={t('title')} />
            <ConfirmResetPasswordView />
        </div>
    );
};
